import { render, staticRenderFns } from "./CreateAccountModal.vue?vue&type=template&id=905aba32&"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js&"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports